export default {
  newDesign: true,
  parameters: {
    landing_id: "SpQD",
    segment: 54,
  },
  title:
    "¡Ayúdanos a crear un plan creativo personalizado para tu hijo! | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title: "¡Ayúdanos a crear un plan creativo personalizado para tu hijo!",
    subtitle:
      "Esto tomará de 1 a 2 minutos y ayudará a elegir el formato y programa ideales 💙",
    image: {
      url: "/welcome/latam_design_desk_v2.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_design_mob_v2.png",
      style: {
        width: "100%",
      },
    },
    button: "Presiona para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  customStopPages: {
    child: {
      title: "Lamentablemente, solo un padre o tutor puede inscribir a un estudiante en las clases.",
      subtitle:
        "Si quieres continuar, puedes compartir este enlace con tus padres.<br>¡Ojalá podamos verte pronto en nuestras clases! ",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "¿Eres mamá, papá, otro familiar o hijo/a?",
      answers: [
        "Soy papá 👨‍🦱",
        "Soy mamá 👩‍🦰",
        "Soy otro familiar / tutor 👵",
        {
          answer: "Soy hijo/a 👧🧒",
          stopAnswer: true,
          customStopPageId: "child",
        },
      ],
    },
    2: {
      question: "¿Qué quieres que tu hijo obtenga del dibujo y la creatividad?",
      answers: [
        {
          answer: "Hobby y creatividad 🎨",
          distribution_tag_question: [120],
        },
        {
          answer: "Preparación profesional 💼",
          distribution_tag_question: [120],
        },
        {
          answer: "Menos pantallas, más provecho 📱",
          distribution_tag_question: [120],
        },
        {
          answer: "Confianza y socialización 🤝",
          distribution_tag_question: [120],
        },
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_tutors.png",
      subtitle:
        "Nuestros profesores experimentados crearán un plan de estudios adaptado a cualquiera de estos objetivos 💙",
      button: "¡Genial!",
    },
    4: {
      question: "¿Qué prefiere crear tu hijo?",
      answers: [
        "Personajes y cómics 🎭",
        "Animación y cartoons 🎬",
        "Paisajes y animales 🌿",
        "De todo un poco 🎨",
      ],
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_recommendations.png",
      subtitle:
        "78% de nuestros estudiantes comienzan a dibujar sus personajes favoritos ya en el primer mes del curso. Y esto es lo que dicen los padres:",
      button: "Continuar ➡️",
    },
    6: {
      question: "¿Qué modalidad de aprendizaje le atrae más?",
      answers: [
        "Dibujo tradicional (papel, lápices) ✏️",
        "Dibujo digital (tableta, computadora) 💻",
        "Quiere probar otras áreas: animación, 3D, diseño gráfico 🚀",
        "No sabe, quiere experimentar",
      ],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_courses.png",
      subtitle:
        "¡En Kodland lo tenemos todo! Cursos para niños y adolescentes: arte digital, dibujo, modelado 3D y diseño gráfico 🎨",
      button: "¿Qué más?",
    },
    8: {
      question: "¿Por qué prefieres clases online?",
      answers: [
        "No hay cursos locales 🏙️",
        "Horarios flexibles ⏰",
        "Mejores profesores 👨‍🏫",
        "Más tecnologías digitales 💻",
        "Otro motivo ✨",
      ],
    },
    9: {
      question: "¿Qué formato prefieres?",
      answers: [
        "Individual 👤",
        "Grupo pequeño (hasta 5) 👥",
        "Grupo grande 🎓",
        "Autoaprendizaje con apoyo 📚",
        "Necesito recomendación 🤔 ",
      ],
    },
    10: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_kids_drawings.png",
      subtitle:
        "¡Perfecto! Elegir el formato nos ayuda a crear clases que tu hijo realmente disfrutará 💙",
      button: "¡Muy bien!",
    },
    11: {
      question: "¿Con qué cuenta tu hijo para dibujar?",
      subtitle: "No te preocupes si falta algo, ¡se puede empezar sin todo!",
      answers: [
        "Tableta con stylus ✏️",
        "Tableta sin stylus 📱",
        "Materiales tradicionales 🎨",
        "Nada aún, vamos a comprar 🛒",
      ],
    },
    12: {
      question:
        "¿Cómo evalúa el nivel actual de habilidades de su hijo en dibujo o creatividad?",
      answers: [
        "Principiante, solo prueba 🌱",
        "Aficionado, dibuja por placer 🎨",
        "Buen nivel 👍",
        "Orientado profesionalmente 🎯",
      ],
    },
    13: {
      question: "¿Qué han probado ya para desarrollar habilidades creativas?",
      answers: [
        "Autodidacta (YouTube, libros) 📚",
        "Otros cursos online 💻",
        "Escuelas offline 🏫",
        "Nada aún 🆕",
        "Otro ✍️",
      ],
    },
    14: {
      question: "¿Qué actividades adicionales asiste su hijo actualmente?",
      answers: [
        "Deportes ⚽",
        "Música 🎵",
        "IT/matemáticas 💻",
        "Arte 🎨",
        "Nada 🆓",
      ],
    },
    15: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_progress.png",
      title: "Tu plan de aprendizaje creativo está listo 🎉",
      subtitle:
        "Empecemos con una clase gratuita donde conocerás nuestra escuela y tu hijo comenzará su viaje creativo. Todo online, con un profesor real de diseño.",
      button: "Me interesa 👀",
    },
    16: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_drawing_boy.png",
      title: "¿Y cómo acceder a la clase?",
      subtitle:
        "Esta clase gratuita está disponible por tiempo limitado. Solo tienes que completar el formulario en el siguiente paso y elegir el horario que más les convenga. Después, te pediremos confirmar tu participación por WhatsApp ¡y listo! 💙",
      button: "Reservar mi clase gratuita 🔥",
    },
    17: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    18: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Casi terminamos 🔥",
    },
    19: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    20: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    21: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    22: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo tienes que hacer clic en el enlace, te llevará directamente a la clase. Sin aplicaciones adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
